export enum CreditFunctionKind {
  /// <summary>
  ///
  /// </summary>
  Warning = 1,
  /// <summary>
  /// توقف
  /// </summary>
  Stop = 2,
}

export enum DebtorCreditorNoticesKind {
  /// سیستمی
  Systemic = 1,
  /// يكشنبه"
  Normal = 2,
}
